/* ---------------------------------------------------------------------------
   TPS: open the Klaviyo No-Hemming List form.

   Mirrors the live pre-launch theme (sections/tps-header.liquid). Any link
   pointing at #join opens Klaviyo sign-up form XkpTSY, which submits to list
   SvMNKp and triggers the live "Welcome - Pre-Launch" flow (XeDEmY).
   Arriving with ?join=1 opens it on load, which is the QR / short-link entry
   point, so a scan lands straight on the form.

   REQUIRES the Klaviyo app embed to be enabled on this theme. Without it
   window._klOnsite never loads and nothing opens.
   --------------------------------------------------------------------------- */
(function () {
  var FORM_ID = 'XkpTSY';

  function openJoinForm() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('a[href$="#join"]');
    if (!trigger) return;
    event.preventDefault();
    openJoinForm();
  });

  try {
    if (new URLSearchParams(window.location.search).has('join')) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', openJoinForm);
      } else {
        openJoinForm();
      }
    }
  } catch (err) {
    /* URLSearchParams unavailable, the click path still works. */
  }
})();
